import { render, staticRenderFns } from "./ManageProcess.vue?vue&type=template&id=29b81065&scoped=true&"
import script from "./ManageProcess.vue?vue&type=script&lang=js&"
export * from "./ManageProcess.vue?vue&type=script&lang=js&"
import style0 from "./ManageProcess.vue?vue&type=style&index=0&id=29b81065&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b81065",
  null
  
)

export default component.exports